var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('TheNavBar',{on:{"click":function($event){return _vm.toggleDrawer()}}}),_c('TheNavDrawer',{attrs:{"status":_vm.drawer}}),_c('v-container',{staticClass:"px-5"},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }